// GENERATED FILE - DO NOT MODIFY
export enum ShopDrawingStatus {
    ToDo = "1",
    Complete = "4",
    Submitted = "7",
    Approuved = "9",
}

export let nameof = "ShopDrawingStatus";
